import loadExternalScript from './loadExternalScript';

export default ({
  page: { productType },
  returnsSettings: {
    [productType]: {
      returnOptions: { enabled: returnOptionsEnabled = false, methods: locatorUiMethods = [] } = {},
      return_methods: defaultUiMethods = [],
    } = {},
  } = {},
}) => {
  const methods = returnOptionsEnabled ? Object.values(locatorUiMethods) : defaultUiMethods;
  const isPaymentsEnabled = methods.some((method) => {
    const { payments: { enabled = false } = {} } = method;
    return enabled;
  });

  if (isPaymentsEnabled) {
    loadExternalScript({ url: 'https://js.stripe.com/v3/' });
  }
};
